import React from 'react';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import toast from 'react-hot-toast';

interface SummaryItem {
  name: string;
  totalCrates: number;
  totalKg: number;
  totalPacks: number;
  totalUnits: number;
}

interface Props {
  summary: SummaryItem[];
}

const ExportSummaryButton: React.FC<Props> = ({ summary }) => {
  const handleExport = async () => {
    if (summary.length === 0) {
      toast.error('No hay datos para exportar.');
      return;
    }

    try {
      const doc = new jsPDF();
      const date = new Date();
      const formattedDate = `${String(date.getDate()).padStart(
        2,
        '0',
      )}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFontSize(18);
      doc.setTextColor(40);
      doc.text('Resumen de mercadería a comprar', pageWidth / 2, 20, {
        align: 'center',
      });

      doc.setFontSize(11);
      doc.setTextColor(100);
      doc.text(`Fecha: ${formattedDate}`, pageWidth / 2, 28, {
        align: 'center',
      });

      const rows = summary.map((item) => [
        item.name,
        item.totalCrates,
        item.totalKg,
        item.totalPacks,
        item.totalUnits,
      ]);

      autoTable(doc, {
        startY: 35,
        head: [['Producto', 'Cajones', 'Kg', 'Paquetes', 'Unidades']],
        body: rows,
        styles: { fontSize: 10 },
        headStyles: {
          fillColor: [85, 180, 100],
          textColor: 255,
          fontStyle: 'bold',
        },
      });

      const pdfBlob = doc.output('blob');
      const blobUrl = URL.createObjectURL(pdfBlob);
      const downloadLink = document.createElement('a');

      downloadLink.href = blobUrl;
      downloadLink.setAttribute('type', 'application/pdf');
      downloadLink.download = `resumen-mercaderia-${formattedDate}.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 5000);

      setTimeout(() => {
        toast.success('Resumen exportado correctamente.');
      }, 100);
    } catch (error) {
      console.error('Error exportando PDF:', error);
      toast.error('Error al generar el resumen.');
    }
  };

  return (
    <button
      className="primary-button margin-top margin-bottom-20"
      onClick={handleExport}
    >
      Exportar resumen
    </button>
  );
};

export default ExportSummaryButton;
